import React from "react";
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Grid } from "@mui/material";
import { motion } from "framer-motion";
import "../../styles/Subpages.css";
import img1 from "../../assets/spans.jpg";
import img2 from "../../assets/wall.jpg";
import img3 from "../../assets/Barbending.jpg";
import img4 from "../../assets/Stair.jpg";
import img5 from "../../assets/Villa5.jpg";
import img6 from "../../assets/Inside.jpg";
import img7 from "../../assets/Commercial1.jpg";
import img8 from "../../assets/Steps.jpg";
import img9 from "../../assets/Compound.jpg";
import img10 from "../../assets/Foot.jpg";
import video1 from "../../assets/videos/slab.mp4";
import video2 from "../../assets/videos/Footings.mp4";

const SubPage8 = () => {
  const packageInfo = {
    title: "Luxury Smart Home Plan",
    subtitle: "Luxury finishes with smart-home integration",
    price: "From ₹2,299 / sq.ft",
    data: [
      { type: "Foundation", rate: "Engineered foundation & ground treatment", duration: "4-6 weeks" },
      { type: "Structure", rate: "High-performance RC frame", duration: "10-14 weeks" },
      { type: "Roofing", rate: "Green roofs / premium insulated systems", duration: "2-4 weeks" },
      { type: "Flooring", rate: "Custom hardwood, marble & designer stones", duration: "2-3 weeks" },
    ],
    description: "The ultimate package for discerning clients seeking luxury finishes, smart-home features and complete customization."
  };

  const media = [img1,img2,img3,img4,img5,img6,img7,img8,img9,img10];

  return (
    <Box className="subpage-container">
      <motion.div initial={{ opacity: 0, y: -30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <Typography variant="h4" className="subpage-title">{packageInfo.title}</Typography>
        <Typography variant="subtitle1" className="subpage-sub">{packageInfo.subtitle} • {packageInfo.price}</Typography>
      </motion.div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
        <Table className="subpage-table">
          <TableHead>
            <TableRow>
              <TableCell><b>Item</b></TableCell>
              <TableCell><b>Specification</b></TableCell>
              <TableCell><b>Duration</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {packageInfo.data.map((row,i) => (
              <TableRow key={i}>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.rate}</TableCell>
                <TableCell>{row.duration}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </motion.div>

<Box className="subpage-pdf">
  <Typography variant="h6" sx={{ mb: 1 }}>
    📄 Essential Home Plan
  </Typography>
  <iframe
    src="/files/luxury_smart_home_plan.pdf"
    width="100%"
    height="600px"
    style={{ border: "1px solid #ccc", borderRadius: "8px" }}
    title="Essential Home Plan"
  ></iframe>
</Box>

      <Grid container spacing={4} justifyContent="center" className="media-grid" style={{ marginTop: 24 }}>
        {media.map((src,i) => (
          <Grid item key={i} xs={12} sm={6} md={4} lg={3}>
            <motion.img src={src} alt={`media-${i}`} className="grid-image" whileHover={{ scale: 1.03 }} transition={{ duration: 0.25 }} />
          </Grid>
        ))}
        {[video1, video2].map((src,i) => (
          <Grid item key={`v-${i}`} xs={12} sm={6} md={4} lg={3}>
            <motion.video src={src} controls className="grid-video" whileHover={{ scale: 1.03 }} transition={{ duration: 0.25 }} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SubPage8;
